<template>
  <div class="news-list-page">
    <div class="news-list" v-if="total!=0">
      <div class="news-item" v-for="(item,index) in newsList" @click="gotoDetail(item.id,item.cate_id)">
        <div class="news-thumb-img-box" v-if="'image' in item && item.image!=''">
          <img class="news-thumb-img" :src="urlConfig + item.image" alt="">
        </div>

        <div class="news-info">
          <div class="news-title overflowHidden1" v-html="textAddColor(item.title,searchWord)"></div>
          <div class="news-content overflowHidden2">{{item.content_omit}}</div>
          <div class="news-time flexBetween">
            <div class="flex">
              {{item.createtime | formatDate}}&nbsp&nbsp&nbsp&nbsp
              <span v-if="'source' in item && item.source">{{item.source}}</span>
            </div>
            <div class="flex look-num-box" v-if="'views' in item">
              <img class="look-num-icon" src="~assets/img/common/lookNum.png" alt="">&nbsp&nbsp{{item.views}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-else>
      <empty-data-tip>
        <template v-slot:tipPic>
          <img src="~assets/img/common/pageLoading.gif" alt="">
        </template>
      </empty-data-tip>
    </template>

    <div class="pagination-box flexColumnCenter">
      <el-pagination
        style="margin:0 auto"
        background
        @current-change="handleCurrentChange"
        :current-page="current_page"
        :page-size="per_page"
        layout="total,prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import {formatDate} from 'utils/tools'
  import EmptyDataTip from "components/common/emptydata/EmptyDataTip";
  export default {
    name: "NewsList",
    components:{
      EmptyDataTip
    },
    props:{
      newsList:{
        type:Array,
        default:()=>{
          return[]
        }
      },
      total:{
        type:Number,
        default:0
      },
      per_page:{
        type:Number,
        default:0
      },
      current_page:{
        type:Number,
        default: 1
      },
      // 搜索关键词
      searchWord:{
        type:String,
        default: ''
      }
    },
    filters: {
      formatDate(time) {
        time = time * 1000
        let date = new Date(time)
        return formatDate(date, 'yyyy-MM-dd')
      }
    },
    methods:{
      // 改变页数
      handleCurrentChange(val) {
        this.$emit('getList',val)
      },
      // 改变指定文字颜色
      textAddColor(paragraph,searchWord){
        if(searchWord=='')return paragraph
        let reg = new RegExp(`${searchWord}`,'g')
        let newText = paragraph.replace(reg,`<span style="color: red">${searchWord}</span>`)
        return newText
      },
      // 跳转新闻详情
      gotoDetail(id,cid){
        // this.$emit('getDetail',id)
        // this.$emit('gotoDetail',{id,cid})
        // this.$router.push({path:'newsdetail',query:{id:id}})
        window.open(`/secondtheme?cid=${cid}&id=${id}`, "_blank");
      }
    }
  }
</script>

<style scoped>
  .news-item{
    display: flex;
    align-items: center;
    width: calc(100% - 50px);
    padding: 20px 30px;
    padding-left: 15px;
    border-bottom: 1px solid #f3f3f3;
    cursor: pointer;
    font-size: 18px;
    color: #000;
    border-left: 5px solid transparent;
  }

  .news-item:hover{
    background-color: #f4f4f4;
    border-left: 5px solid #74ba28;
  }

  .news-thumb-img-box{
    flex-shrink: 0;
    flex-grow: 0;
    width: 180px;
    height: 120px;
    margin-right: 20px;
  }

  .news-thumb-img{
    display: block;
    width: 180px;
    height: 120px;
    object-fit: cover;
  }

  .news-source{
    font-family: SourceHeavy;
    font-size: 16px;
  }

  .news-info{
    width: calc(100% - 200px);
    flex: 1;
  }
  .news-item:hover .news-title,.news-item:hover .news-content{
    color: var(--color-cursor);
  }

  .news-title{
    width: 100%;
    font-family: SourceRegular;
    font-size: 18px;
    color: #000;
    line-height: 30px;
    margin-bottom: 10px;
  }

  .news-content{
    font-family: SourceRegular;
    font-size: 14px;
    color: #999;
    line-height: 24px;
    margin-bottom: 10px;
    text-align: justify;
  }

  .news-time{
    font-family: SourceNormal;
    font-size: 14px;
    color: #a3afb9;
    line-height: 22px;
  }

  .look-num-box{
    width: 80px;text-align: left
  }

  .look-num-icon{
    display: block;
    width: 18px;
    height: 18px;
  }

  .news-item:hover{
    color: #065da1;
  }

  .pagination-box{
    width: 100%;
    margin-top: 66px;
    margin-bottom: 56px;
  }
</style>
